import Message from "./Message"

const Messages = ({ oldChat, colorData }) => {
  return (
    <div className="messages">
        <Message oldChat={oldChat} colorData={colorData} />
    </div>
  )
}

export default Messages